import React from 'react';
import classNames from 'classnames';
import styles from './credits.module.scss';
import { CreditsInterface } from './credits.interface';

const Credits: React.FunctionComponent<CreditsInterface> = ({
  className,
}) => {
  return (
    <div
      className={classNames(
        styles.component,
        className,
      )}
    >
      <p className={styles.group}>
        <span>Продюсер: Александра Барышева </span>
        <span>Разработка и дизайн: IT Lavka </span>
      </p>

      <p className={styles.group}>
        <span>Авторы: Ирина Телицына, </span>
        <span>Иван Просветов </span>
      </p>

      <p className={styles.group}>
        <span>Продюсер съемки: Алена Варначева </span>
        <span>Видеосъемки: Кирилл Волков </span>
      </p>

      <p className={styles.group}>
        <span>Визажист: Александра Яворская </span>
        <span>Подкасты: Алексей Воробьев </span>
      </p>
    </div>
  );
};

export default Credits;
